import api from "@/plugins/api";
import { appendQuery } from "@/shared/utils/url";
const BASE_PATH = "opink-files";
/**
 * API client for file upload operations.
 * Used by Unlayer's Custom File Storage callback.
 */
export const filesApi = {
    /**
     * Uploads a file to the backend (MinIO storage via OPINK).
     * @param formData - The file as FormData
     * @param fileType - The type of file: 'TemplateThumbnail' or 'EditorImage'
     * @param fileIdentifier - Optional: identifier for the file (e.g., templateId)
     */
    async uploadFile(formData, fileType, fileIdentifier) {
        const url = appendQuery(`${BASE_PATH}/upload`, {
            fileType,
            fileIdentifier,
        });
        const response = await api.post(url, formData, {
            unwrapEnvelope: true,
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    },
};
